import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const SQL_DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const parsePickerDatetime = (value) => {
    if (!value) return null;
    const sqlDatetime = dayjs(value, SQL_DATETIME_FORMAT, true);
    if (sqlDatetime.isValid()) return sqlDatetime;
    const parsed = dayjs(value);
    return parsed.isValid() ? parsed : null;
};

// MUI Components
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

// Components
import Dropdown from '../form-fields/dropdown';

const AlertForm = ({
    selectedSites = [],
    allSites = false,
    handleClose,
    existingAlert = null,
    content: sharedContent,
    setContent: setSharedContent,
    schedule: sharedSchedule,
    setSchedule: setSharedSchedule,
}) => {

    const isCreate = null === existingAlert;

    const [schedule, setSchedule]               = useState(true);
    const [startDatetime, setStartDatetime]     = useState(null);
    const [endDatetime, setEndDatetime]         = useState(null);

    const [ noticeType, setNoticeType ]         = useState('error');
    const [ content, setContent ]               = useState('');

    const scheduleValue = isCreate ? sharedSchedule : schedule;
    const setScheduleValue = isCreate ? setSharedSchedule : setSchedule;
    const contentValue = isCreate ? sharedContent : content;
    const setContentValue = isCreate ? setSharedContent : setContent;

    const saveAlert = () => {
        let args = {
            type: 'notification',
            schedule: scheduleValue,
            content: contentValue,
            notice_type: noticeType
        };
        if( scheduleValue ){
            if( startDatetime ){
                args.start_datetime = startDatetime.format('YYYY-MM-DD HH:mm:ss');
            }
            if( endDatetime ){
                args.end_datetime = endDatetime.format('YYYY-MM-DD HH:mm:ss');
            }
        }
        if( existingAlert ){
            axios.post('/notice/' + existingAlert.id + '/update', args).then(response => {
                if( response.status === 200 && !response.data.error ){
                    toast.success(response.data.message);
                }
                else{
                    toast.error(response.data.message);
                }
                handleClose();
            });
        }
        else{
            args.sites = selectedSites;
            args.all_sites = allSites;
            axios.post('/create-bulk-notices', args).then(response => {
                if( response.status === 200 && !response.data.error ){
                    toast.success(response.data.message);
                }
                else{
                    toast.error(response.data.message);
                }
                handleClose();
            });
        }
    }

    useEffect(() => {
        if( existingAlert ){
            console.log(existingAlert.type);
            setNoticeType(existingAlert.type);
            setSchedule(!existingAlert.is_sent);
            setStartDatetime(parsePickerDatetime(existingAlert.start_datetime));
            setEndDatetime(parsePickerDatetime(existingAlert.end_datetime));
            setContent(existingAlert.message);
        }
    }, [existingAlert]);

    return (
        <Box className='form'>
            <Box className='alert-form-field'>
                <Dropdown
                    label='Notice Type'
                    name='notice_type'
                    options={[
                        { label: 'Error', value: 'error' },
                        { label: 'Warning', value: 'warning' },
                        { label: 'Info', value: 'info' },
                        { label: 'Success', value: 'success' },
                    ]}
                    value={noticeType}
                    onChange={(e) => setNoticeType(e.target.value)}
                />
            </Box>
            <Box className='alert-form-field'>
                <TextField
                    label='Content'
                    name='content'
                    value={contentValue}
                    onChange={(e) => setContentValue(e.target.value)}
                    multiline
                    minRows={10}
                    fullWidth
                />
            </Box>
            <ButtonGroup>
                <Button onClick={() => setScheduleValue(true)} variant={scheduleValue ? 'contained' : 'outlined'}>Schedule</Button>
                <Button onClick={() => setScheduleValue(false)} variant={!scheduleValue ? 'contained' : 'outlined'}>Send</Button>
            </ButtonGroup>
            <Box className='alert-form-field'>
                {scheduleValue && (
                    <Box className='schedule-fields'>
                        <DateTimePicker
                            label='Start Datetime'
                            name='startDatetime'
                            value={startDatetime}
                            onChange={(e) => setStartDatetime(e)}
                            TimeZone='America/Toronto'
                        />
                        <DateTimePicker
                            label='End Datetime'
                            name='endDatetime'
                            value={endDatetime}
                            onChange={(e) => setEndDatetime(e)}
                            TimeZone='America/Toronto'
                        />
                    </Box>
                )}
            </Box>
            <Box className='alert-form-field'>
                {scheduleValue ? (
                    <Button onClick={() => saveAlert()} variant='contained'>Save</Button>
                ) : (
                    <Button onClick={() => saveAlert()} variant='contained'>
                        {existingAlert
                            ? 'Update'
                            : allSites
                                ? 'Send to All Sites'
                                : 'Send to ' + selectedSites.length + ' client' + (selectedSites.length > 1 ? 's' : '')}
                    </Button>
                )}
            </Box>
        </Box>
    )

}

export default AlertForm;
